var map = {
	"./en/cabinet.json": "fpHV",
	"./en/dentisterie.json": "lEWh",
	"./en/footer.json": "956+",
	"./en/home.json": "9vPi",
	"./en/implantologie.json": "ggBF",
	"./en/links.json": "oOAm",
	"./en/menu.json": "NQp8",
	"./en/protheses.json": "4PDE",
	"./en/urgences.json": "4Bm6",
	"./fr/cabinet.json": "dZ1b",
	"./fr/dentisterie.json": "+BAI",
	"./fr/footer.json": "6ptE",
	"./fr/home.json": "7FpN",
	"./fr/implantologie.json": "vgeZ",
	"./fr/links.json": "hOZY",
	"./fr/menu.json": "lRi5",
	"./fr/protheses.json": "/INl",
	"./fr/urgences.json": "2nau"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Ixrx";